import { createApp } from 'vue';
import { plugin } from '@formkit/vue'
import config from '../../formkit.config.js';
import '@formkit/themes/genesis';
import App from './App.vue';
import router from './router';  // Import the router
import pinia from './store';    // Import the Pinia store
import { useAuthStore } from './store/auth';  // Import auth store
import * as Sentry from "@sentry/vue";
import './bootstrap';  // Import axios configuration

// Add error handling for PWA context
window.addEventListener('error', (e) => {
    console.error('Vue app initialization error:', e);
});

window.addEventListener('unhandledrejection', (e) => {
    console.error('Unhandled promise rejection:', e);
});

try {
    const app = createApp(App);

    Sentry.init({
      app,
      dsn: "https://7aff85a4117a9c10b66df10b7e7f445e@o4508711091240960.ingest.us.sentry.io/4508711093272576",
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/.*\/api/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });

    // Registered once, from formkit.config.js (pro plugin + local icons + theme).
    // Previously this ran twice with conflicting configs; Vue silently ignored the
    // second call, so the pro/theme setup only worked by accident.
    app.use(plugin, config)
    app.use(router);  // Use Vue Router
    app.use(pinia);   // Use Pinia for state management

    // Add mount with error handling
    app.mount('#app');
    
    // Initialize auth store after mounting
    setTimeout(() => {
        const authStore = useAuthStore();
        authStore.init();
    }, 100);
    
    console.log('Vue app mounted successfully');
    
    // Remove loading message after successful mount
    setTimeout(() => {
        const loadingElements = document.querySelectorAll('[style*="Loading"]');
        loadingElements.forEach(el => el.remove());
    }, 100);
    
} catch (error) {
    console.error('Failed to initialize Vue app:', error);
    // Fallback error display
    const appEl = document.getElementById('app');
    if (appEl) {
        appEl.innerHTML = `
            <div style="padding: 20px; text-align: center; color: #721c24; background: #f8d7da; border: 1px solid #f5c6cb; margin: 20px; border-radius: 5px;">
                <h2>App Loading Error</h2>
                <p>Failed to initialize the application.</p>
                <p>Error: ${error.message}</p>
                <button onclick="location.reload()" style="padding: 10px 20px; background: #007cba; color: white; border: none; border-radius: 3px; cursor: pointer;">Refresh Page</button>
            </div>
        `;
    }
}
